import {
  StatusBadge,
  type StatusBadgeStatus,
  StatusBadgeStatuses,
} from '@procurify/ui'
import { type IntlShape } from 'react-intl'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  OrderStatuses,
  type OrderStatusEnum,
} from '../../entities/enums/OrderStatusEnum'

const getType = (status: OrderStatusEnum): StatusBadgeStatus => {
  switch (status) {
    case OrderStatuses.PENDING:
    case OrderStatuses.DRAFT:
      return StatusBadgeStatuses.INCOMPLETE
    case OrderStatuses.APPROVED:
    case OrderStatuses.PURCHASED:
      return StatusBadgeStatuses.IN_PROGRESS
    case OrderStatuses.RECEIVED:
      return StatusBadgeStatuses.SUCCESS
    case OrderStatuses.CANCELLED:
    case OrderStatuses.REJECTED:
      return StatusBadgeStatuses.WARNING
    default:
      return StatusBadgeStatuses.INACTIVE
  }
}

const getText = (intl: IntlShape, status: OrderStatusEnum) => {
  switch (status) {
    case OrderStatuses.PENDING:
      return intl.formatMessage(messages.statusTextPending)
    case OrderStatuses.DRAFT:
      return intl.formatMessage(messages.statusTextDraft)
    case OrderStatuses.APPROVED:
      return intl.formatMessage(messages.statusTextApproved)
    case OrderStatuses.RECEIVED:
      return intl.formatMessage(messages.statusTextReceived)
    case OrderStatuses.PURCHASED:
      return intl.formatMessage(messages.statusTextPurchased)
    case OrderStatuses.CANCELLED:
      return intl.formatMessage(messages.statusTextCancelled)
    case OrderStatuses.REJECTED:
      return intl.formatMessage(messages.statusTextRejected)
    default:
      return intl.formatMessage(messages.statusTextUnknown)
  }
}

interface IOrderStatusLabelProps {
  status: OrderStatusEnum
  size?: 'md' | 'lg'
}

export const OrderStatusLabel = ({
  status,
  size = 'md',
}: IOrderStatusLabelProps) => {
  const intl = useProcurifyIntl()

  return (
    <StatusBadge
      aria-label={intl.formatMessage(messages.statusAriaLabel)}
      size={size === 'md' ? 'small' : 'medium'}
      type={getType(status)}
      text={getText(intl, status)}
    />
  )
}
